import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import movingPlayerGif from "../../../assets/gifs/playerMovingGif.gif";
import arrowButtonImg from "../../../assets/keyArrow.png";
import onePlayerImg from "../../../assets/onePlayer.png";
import homeImg from "../../../assets/home.png";
import schoolImg from "../../../assets/school.png";
import officeImg from "../../../assets/office.png";
import playGroundImg from "../../../assets/playground.png";
import gardenImg from "../../../assets/garden.png";
import "../modal.css";
import "./InstructionInfoModal.css";
const InstructionInfoModal = (props) => {
  // const [show, setShow] = useState(false);

  return (
    <>
      {/* <Button variant="primary" onClick={() => setShow(true)}>
        Custom Width Modal
      </Button> */}

      <Modal
        show={props.show}
        size="lg"
        onHide={props.onHide}
        dialogClassName="modal-90w"
        scrollable
        className="InstructionInfoModal-class"
        aria-labelledby="example-custom-modal-styling-title"
        // style={{ overflow: 'auto'}}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        {/* <Modal.Dialog scrollable 
      className='PersonalInfoModalDiagram-class' */}

        {/* > */}
        <Modal.Header
          className="modal-header"
          // style={{
          //   background: "#AF441C",
          //   paddingTop: "2px",
          //   paddingBottom: "2px",
          // }}
          closeButton
        >
          <Modal.Title
            id="example-custom-modal-styling-title"
            style={{ width: "100%", textAlign: "center" }}
          >
            <h2> INSTRUCTIONS </h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="InstructionInfoModalBody-class"
          // style={{width: '100vw'}}
        >
          <div className="instruction-body-wrapper">
            <div className="moving-player-instruction-div">
              <p style={{ fontWeight: "bolder", fontSize: "2.5vw" }}>
                Do you know? You can move freely in my world.
              </p>
              <img
                src={arrowButtonImg}
                alt="arrowButtonImg"
                className="arrow-button-img"
                // style={{ width: "100px", height: "70px" }}
              />
              <img
                src={movingPlayerGif}
                alt="playerMovingGif"
                className="player-moving-gif"
                // style={{ width: "200px", height: "100px" }}
              />
            </div>
            <div className="walk-into-buildings-instruction-div">
              <p
                style={{
                  textAlign: "center",
                  fontWeight: "bolder",
                  fontSize: "2.5vw",
                  marginBottom: "4vh",
                  marginTop: "8vh",
                }}
              >
                To know about me, click or walk into the below places!
              </p>
              <div className="player-click">
                Click <strong>ME</strong>
                &nbsp;
                <img
                  src={onePlayerImg}
                  alt="onePlayerImg"
                  className="one-player-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To know about my <strong>SKILL SETS</strong>
              </div>
              <div className="home-click">
                Click or walk into my <strong>HOME</strong> &nbsp;
                <img
                  src={homeImg}
                  alt="homeImg"
                  className="info-building home-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To <strong>CONTACT WITH ME</strong>
              </div>
              <div className="school-click">
                Click or walk into my <strong>SCHOOL</strong> &nbsp;
                <img
                  src={schoolImg}
                  alt="homeImg"
                  className=" info-building home-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To know about my <strong>ACADEMIC INFORMATIONS.</strong>
              </div>
              <div className="office-click">
                Click or walk into my <strong>OFFICE</strong> &nbsp;
                <img
                  src={officeImg}
                  alt="officeImg"
                  className="info-building office-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To know about my <strong>WORK EXPERIENCES</strong>
              </div>
              <div className="playground-click">
                Click or walk into my <strong>PLAYGROUND</strong> &nbsp;
                <img
                  src={playGroundImg}
                  alt="playGroundImg"
                  className="info-building playground-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To know explore my <strong>PERSONAL PROJECTS</strong>
              </div>
              <div className="garden-click">
                Click or walk into my <strong>GARDEN</strong> &nbsp;
                <img
                  src={gardenImg}
                  alt="gardenImg"
                  className="info-building garden-img"
                  // style={{ width: "100px", height: "70px" }}
                />
                &nbsp; To know explore my <strong>HOBBIES.</strong>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          className="modal-footer"
          // style={{
          //   background: "#AF441C",
          //   paddingTop: "2px",
          //   paddingBottom: "2px",
          // }}
        >
          <div className="modal-got-it-btn-div">
            <Button
              // variant="primary"
              onClick={props.onHide}
            >
              GOT IT!
            </Button>
          </div>
          {/* <button  onClick={props.onHide}>CLOSE</button> */}
        </Modal.Footer>
        {/* </Modal.Dialog> */}
      </Modal>
    </>
  );
};

export default InstructionInfoModal;
